import { config, handleResponse } from '../../_helpers';

export const DBRoleService = {
    getAllDBRole,
};


function getAllDBRole() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/DbconstantsRoles`, requestOptions).then(handleResponse);
}
